import React, { useContext, useEffect, useState } from 'react';

import { PagesContext } from '../store/PagesContext';

import UList from 'components/Lists/UList';

import Columns from '../components/Columns';
import AMTPopup from '../components/popups/AMTPopup';

const IsoI = () => {
  const [, setLastPage] = useContext(PagesContext);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const openPopup = () => setIsPopupOpen(true);

  useEffect(() => setLastPage('isoG'), []);

  const sideContent = 'If you sell your shares more than 1 year after exercising and 2 years after your grant date then:';

  return (
    <>
      <Columns sideContent={sideContent} theme='purple'>
        <UList theme='purple'>
          <li>You do not have to pay ordinary income tax.</li>
          <li>Instead, your shares will qualify as long-term capital gains meaning they will be taxed below the normal income tax rate.</li>
          <li>
            Further, in order to see if you qualify for an AMT (alternative minimum tax) credit for the year of exercise, you may need to
            calculate your gains{' '}
            <span onClick={openPopup} className='color-purple c-pointer'>
              separately for AMT
            </span>
            .
          </li>
          <li>You may also be required to pay estimated taxes on a quarterly basis.</li>
        </UList>
      </Columns>

      <AMTPopup isPopupOpen={isPopupOpen} setIsPopupOpen={setIsPopupOpen} />
    </>
  );
};

export default IsoI;
